export default "__VITE_ASSET__McTY$aVG__"